// Browsers
var _ie, _firefox, _opera, _webkit, _chrome

// Actual IE browser for compatibility mode
var _ie_real_version

// Platforms
var _osx, _windows, _linux, _android

// Architectures
var _win64

// Devices
var _iphone, _ipad, _native

var _mobile

var _populated = false

function _populate() {
	if (_populated) {
		return
	}

	_populated = true

	var uas = navigator.userAgent
	var agent =
		/(?:MSIE.(\d+\.\d+))|(?:(?:Firefox|GranParadiso|Iceweasel).(\d+\.\d+))|(?:Opera(?:.+Version.|.)(\d+\.\d+))|(?:AppleWebKit.(\d+(?:\.\d+)?))|(?:Trident\/\d+\.\d+.*rv:(\d+\.\d+))/.exec(
			uas
		)
	var os = /(Mac OS X)|(Windows)|(Linux)/.exec(uas)

	_iphone = /\b(iPhone|iP[ao]d)/.exec(uas)
	_ipad = /\b(iP[ao]d)/.exec(uas)
	_android = /Android/i.exec(uas)
	_native = /FBAN\/\w+;/i.exec(uas)
	_mobile = /Mobile/i.exec(uas)

	_win64 = !!/Win64/.exec(uas)

	if (agent) {
		_ie = agent[1] ? parseFloat(agent[1]) : agent[5] ? parseFloat(agent[5]) : NaN
		if (_ie && document && document.documentMode) {
			_ie = document.documentMode
		}
		var trident = /(?:Trident\/(\d+.\d+))/.exec(uas)
		_ie_real_version = trident ? parseFloat(trident[1]) + 4 : _ie

		_firefox = agent[2] ? parseFloat(agent[2]) : NaN
		_opera = agent[3] ? parseFloat(agent[3]) : NaN
		_webkit = agent[4] ? parseFloat(agent[4]) : NaN
		if (_webkit) {
			agent = /(?:Chrome\/(\d+\.\d+))/.exec(uas)
			_chrome = agent && agent[1] ? parseFloat(agent[1]) : NaN
		} else {
			_chrome = NaN
		}
	} else {
		_ie = _firefox = _opera = _chrome = _webkit = NaN
	}

	if (os) {
		if (os[1]) {
			var ver = /(?:Mac OS X (\d+(?:[._]\d+)?))/.exec(uas)
			_osx = ver ? parseFloat(ver[1].replace('_', '.')) : true
		} else {
			_osx = false
		}
		_windows = !!os[2]
		_linux = !!os[3]
	} else {
		_osx = _windows = _linux = false
	}
}

var UserAgent_DEPRECATED = {
	ie: function () {
		return _populate() || _ie
	},
	ieCompatibilityMode: function () {
		return _populate() || _ie_real_version > _ie
	},

	ie64: function () {
		return UserAgent_DEPRECATED.ie() && _win64
	},
	firefox: function () {
		return _populate() || _firefox
	},
	opera: function () {
		return _populate() || _opera
	},
	webkit: function () {
		return _populate() || _webkit
	},
	safari: function () {
		return UserAgent_DEPRECATED.webkit()
	},
	chrome: function () {
		return _populate() || _chrome
	},
	windows: function () {
		return _populate() || _windows
	},
	osx: function () {
		return _populate() || _osx
	},
	linux: function () {
		return _populate() || _linux
	},
	iphone: function () {
		return _populate() || _iphone
	},
	mobile: function () {
		return _populate() || _iphone || _ipad || _android || _mobile
	},

	nativeApp: function () {
		return _populate() || _native
	},

	android: function () {
		return _populate() || _android
	},

	ipad: function () {
		return _populate() || _ipad
	},
}

var canUseDOM = !!(
	typeof window !== 'undefined' &&
	window.document &&
	window.document.createElement
)

var ExecutionEnvironment = {
	canUseDOM: canUseDOM,

	canUseWorkers: typeof Worker !== 'undefined',

	canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

	canUseViewport: canUseDOM && !!window.screen,

	isInWorker: !canUseDOM,
}

var useHasFeature
if (ExecutionEnvironment.canUseDOM) {
	useHasFeature =
		document.implementation &&
		document.implementation.hasFeature &&
		document.implementation.hasFeature('', '') !== true
}

function isEventSupported(eventNameSuffix, capture) {
	if (!ExecutionEnvironment.canUseDOM || (capture && !('addEventListener' in document))) {
		return false
	}

	var eventName = 'on' + eventNameSuffix
	var isSupported = eventName in document

	if (!isSupported) {
		var element = document.createElement('div')
		element.setAttribute(eventName, 'return;')
		isSupported = typeof element[eventName] === 'function'
	}

	if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
		isSupported = document.implementation.hasFeature('Events.wheel', '3.0')
	}

	return isSupported
}

;(function () {
	'use strict'

	var PIXEL_STEP = 10
	var LINE_HEIGHT = 40
	var PAGE_HEIGHT = 800

	function normalizeWheel(event) {
		var sX = 0,
			sY = 0,
			pX = 0,
			pY = 0
		if ('detail' in event) sY = event.detail
		if ('wheelDelta' in event) sY = -event.wheelDelta / 120
		if ('wheelDeltaY' in event) sY = -event.wheelDeltaY / 120
		if ('wheelDeltaX' in event) sX = -event.wheelDeltaX / 120
		if ('axis' in event && event.axis === event.HORIZONTAL_AXIS) {
			sX = sY
			sY = 0
		}
		pX = sX * PIXEL_STEP
		pY = sY * PIXEL_STEP
		if ('deltaY' in event) pY = event.deltaY
		if ('deltaX' in event) pX = event.deltaX
		if ((pX || pY) && event.deltaMode) {
			if (event.deltaMode == 1) {
				pX *= LINE_HEIGHT
				pY *= LINE_HEIGHT
			} else {
				pX *= PAGE_HEIGHT
				pY *= PAGE_HEIGHT
			}
		}
		if (pX && !sX) sX = pX < 1 ? -1 : 1
		if (pY && !sY) sY = pY < 1 ? -1 : 1
		return { spinX: sX, spinY: sY, pixelX: pX, pixelY: pY }
	}

	normalizeWheel.getEventType = function () {
		return 'onwheel' in document ? 'wheel' : 'mousewheel'
	}

	// Attach the normalizeWheel function to the global window object
	window.normalizeWheel = normalizeWheel
})()
